"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Box, AspectRatio } from "@mantine/core";
import { forwardRef, createRef } from "react";
import '../../../assets/Video.css';const root = "_root_1qm1e_2";
const backgroundVideo = "_backgroundVideo_1qm1e_14";
const content = "_content_1qm1e_33";
const VideoStyles = {
  root,
  backgroundVideo,
  content
};
const _Video = forwardRef((props, ref) => {
  const {
    children,
    ratio = 16 / 9,
    allowFullscreen,
    title,
    src,
    controls = true,
    poster,
    loop = false,
    muted = false,
    autoPlay = false,
    pt,
    pb,
    pl,
    pr,
    p,
    className,
    ...rest
  } = props;
  const videoRef = createRef();
  const srcIsLocal = !src.includes("https://");
  const element = srcIsLocal ? /* @__PURE__ */ jsxs(
    "video",
    {
      ref: videoRef,
      width: "100%",
      height: "100%",
      controls: children ? false : controls,
      poster,
      loop,
      muted: autoPlay ? true : muted,
      autoPlay,
      children: [
        /* @__PURE__ */ jsx("source", { src, type: "video/mp4" }),
        /* @__PURE__ */ jsx("track", { kind: "captions" })
      ]
    }
  ) : /* @__PURE__ */ jsx(
    "iframe",
    {
      src,
      title,
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: allowFullscreen
    }
  );
  return children ? /* @__PURE__ */ jsxs(Box, { ...rest, className: `${VideoStyles.root} ${className}`, ref, children: [
    /* @__PURE__ */ jsx(Box, { className: VideoStyles.backgroundVideo, children: element }),
    /* @__PURE__ */ jsx(Box, { p, pl, pr, pt, pb, className: VideoStyles.content, children })
  ] }) : /* @__PURE__ */ jsx(
    AspectRatio,
    {
      ...rest,
      ratio,
      ref,
      p,
      pl,
      pr,
      pt,
      pb,
      className: `${VideoStyles.root} ${className}`,
      children: element
    }
  );
});
_Video.displayName = "Video";
const Video = sharedHandler(_Video);
Video.displayName = _Video.displayName;
export {
  VideoStyles as V,
  Video as default
};
